module.exports = __webpack_public_path__ + "static/media/plusIcon.c0f37ca8.svg";